import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "./common.module.scss";
import { File, MapsData, Order, User } from "../../../services";
import OrdersInfoCargo from "./components/OrdersInfoCargo";
import OrdersInfoHeader from "./components/OrdersInfoHeader";
import OrdersInfoBasic from "./components/OrdersInfoBasic";
import OrdersInfoDirections from "./components/OrdersInfoDirections";
import OrdersDriverInfo from "./components/OrdersDriverInfo";
import InfoIcon from "../../shared/icons/InfoIcon";
import Loading from "../../shared/Loading/Loading";
import { toast } from "react-toastify";
import OrderHistory from "./components/OrderHistory";
import SuggestPrice from "./components/SuggestPrice";
import ListSuggestedPrices from "./components/ListSuggestedPrices";
import { useSelector } from "react-redux";
import OrderDecision from "./components/OrderDecision";
import AssignDriver from "./components/AssignDriver";
import AssignExecutor from "./components/AssignExecutor";
import TrackingLink from "./components/TrackingLink";
import OrdersInfoAddressList from "./components/OrdersInfoAddressList";
import AssignYourDriver from "./components/AssignYourDriver";

// ORDER CARD FOR THE EXPEDITOR
const OrdersСard = ({
  isOpen,
  setIsOpen,
  orderId,
  companyName,
  onForceUpdate,
  isShowOrderSolution = false,
  isSearchPage = false,
}) => {
  const { user } = useSelector((state) => state);

  const [getOrder, setOrder] = useState(null);
  const [cargoDetails, setCargoDetails] = useState();
  const [recipient, setRecipient] = useState();
  const [bookingDate, setBookingDate] = useState();
  const [statusHistory, setStatusHistory] = useState();
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);
  const [coordinate, setCoordinate] = useState([]);
  const [listDocDriver, setListDocDriver] = useState([]);
  const [driverPhotos, setDriverPhotos] = useState([]);
  const [listSuggestedPrice, setListSuggestedPrice] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);

  const fetchOrderData = async () => {
    setLoading(true);
    if (orderId) {
      try {
        const { data } = await Order.getOrderById(orderId);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart =
            data.shippingHourFrom < 10
              ? `0${data.shippingHourFrom}`
              : data.shippingHourFrom;
          const timeEnd =
            data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10
              ? `0${data.unloadingHourFrom}`
              : data.unloadingHourFrom;
          const timeEnd =
            data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error("Произошла ошибка, попробуйте позже");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setIsLoadingMap(true);
    setRouteData(null);

    if (getOrder) {
      MapsData.getRoute(getOrder.cityIdFrom, getOrder.cityIdTo)
        .then((response) => {
          try {
            let parsedData = JSON.parse(response.data.jsonData);

            if (response.data.fromCityId !== getOrder.cityIdFrom) {
              parsedData = parsedData.reverse();
            }
            if (response) {
              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } else {
              setRouteData(null);
            }
            setIsLoadingMap(false);
          } catch (error) {
            console.error("Ошибка при парсинге JSON:", error);
            setRouteData(null);
            setIsLoadingMap(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoadingMap(true);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      Order.getCargo(getOrder.cargoId)
        .then((response) => {
          if (response.status == 200) {
            setCargoDetails(response.data);
          } else {
            setCargoDetails({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      Order.getRecipient(getOrder.recipientId)
        .then((response) => {
          if (response.status == 200) {
            setRecipient(response.data);
          } else {
            setRecipient({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      User.getHistory(orderId)
        .then((res) => res.data)
        .then((data) => {
          setBookingDate(data[3]?.createdAt);
          setStatusHistory(data);
        })
        .catch((error) => {
          console.log(error);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      Order.getCityById(getOrder.cityIdFrom)
        .then((response) => {
          if (response.status == 200) {
            setCityFrom(response.data);
          } else {
            setCityFrom(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      Order.getCityById(getOrder.cityIdTo)
        .then((response) => {
          if (response.status == 200) {
            setCityTo(response.data);
          } else {
            setCityTo(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Произошла ошибка, попробуйте позже");
        });

      User.getCoordinate(getOrder.number)
        .then((response) => {
          if (response.status == 200) {
            const post = [];
            if (response.data && response.data.length) {
              response.data.map((m) => {
                post.push({
                  lat: m.latitude,
                  lng: m.longitude,
                  date: m.createdAtStr,
                });
              });
            }
            setCoordinate(post);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (getOrder && getOrder.driverId) {
        File.getDocList(getOrder.driverId)
            .then((response) => {
              const filteredData = response.data.filter((doc) => doc.type !== 8);
              const hasTypes = [4, 5, 7].some((type) =>
                  filteredData.some((doc) => doc.type === type),
              );

              setListDocDriver(filteredData);

              if (!hasTypes && getOrder.vehicleId) {
                File.getDocListVehicle(getOrder.vehicleId)
                    .then((vehicleResponse) => {
                      const combinedData = [...filteredData, ...vehicleResponse.data];
                      setListDocDriver(combinedData);
                    })
                    .catch((error) => {
                      console.log("Ошибка при получении документов ТС:", error);
                    });
              }
            })
            .catch((error) => {
              console.log("Ошибка при получении документов водителя:", error);
            });
      } else if (getOrder && getOrder.vehicleId) {
        File.getDocListVehicle(getOrder.vehicleId)
            .then((vehicleResponse) => {
              setListDocDriver(vehicleResponse.data);
            })
            .catch((error) => {
              console.log("Ошибка при получении документов ТС:", error);
            });
      } else {
        console.log("Невозможно получить документы: ID водителя и ТС не определены");
        setListDocDriver([]);
      }

      File.getOrderDocsDriverPhotos(getOrder.id)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setDriverPhotos(response.data);
          }
        })
        .catch((error) => {
          console.log("error order docs", error);
        });

      if (user.type === "Client") {
        Order.getListSuggestedPrice(getOrder.id)
          .then((response) => {
            setListSuggestedPrice(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [getOrder]);

  useEffect(() => {
    fetchOrderData();
  }, [orderId]);

  return (
    <div className={cn(style.wrapper, { [style.open]: isOpen })}>
      <OrdersInfoHeader
        item={getOrder}
        setIsOpen={setIsOpen}
        onForceUpdate={onForceUpdate}
        userType={user?.type}
        companyId={user?.companyId}
      />
      {isLoading ? <Loading borderRadius="16px" /> : null}
      <div className={style.orders_content}>
        <OrdersInfoBasic
          item={getOrder}
          onOpen={() => setIsOpenModalHistory(true)}
          userType={user?.type}
          companyId={user?.companyId}
        />
        {isOpenModalHistory ? (
          <OrderHistory
            item={getOrder}
            isOpen={isOpenModalHistory}
            statusHistory={statusHistory}
            onClose={() => setIsOpenModalHistory(false)}
            senderName={companyName}
            recipientName={recipient?.name}
            cargoDetails={cargoDetails}
            cityFrom={cityFrom}
            cityTo={cityTo}
            routeData={routeData}
            isLoadingMap={isLoadingMap}
            routeStartCity={routeStartCity}
            coordinateTruck={coordinate}
            bookingDate={bookingDate}
            driverPhotos={driverPhotos}
            listDocDriver={listDocDriver}
          />
        ) : null}

        {getOrder && getOrder.addressList.length < 1 ? (
          <OrdersInfoDirections
            item={getOrder}
            senderName={companyName}
            recipientName={recipient?.name}
          />
        ) : (
          <OrdersInfoAddressList order={getOrder} addressList={getOrder?.addressList} />
        )}

        {isShowOrderSolution &&
          getOrder &&
          getOrder.expeditorId &&
          getOrder.isPublic === false &&
          getOrder.status === "unloadingcargomoderation" && (
            <OrderDecision
              item={getOrder}
              onUpdateData={() => onForceUpdate()}
              fetchOrderData={fetchOrderData}
            />
          )}
        {/* {isSuggestPrice &&
          getOrder &&
          getOrder.status === "awaitingoffer" &&
          !getOrder.expeditorId && (
            <SuggestPrice
              item={getOrder}
              onUpdateData={() => onForceUpdate()}
              tenderOrderInfo={tenderOrderInfo || []}
            />
          )} */}

        {/* {isAssignDriver &&
          getOrder &&
          getOrder.status === "published" &&
          getOrder.expeditorId && (
            <AssignDriver
              user={user}
              orderId={getOrder.id}
              onUpdateData={() => onForceUpdate()}
            />
          )} */}
        {getOrder &&
          getOrder?.status === "published" &&
          (isSearchPage ? (
            <AssignExecutor
              user={user}
              orderId={getOrder?.id}
              onUpdateData={() => onForceUpdate()}
              fetchOrderData={fetchOrderData}
            />
          ) : (
            <AssignYourDriver
              user={user}
              orderId={getOrder?.id}
              onUpdateData={() => onForceUpdate()}
              fetchOrderData={fetchOrderData}
            />
          ))}

        {getOrder && getOrder.driverId && (
          <OrdersDriverInfo
            item={getOrder}
            driverId={getOrder.driverId}
            recipientName={recipient?.name}
            senderName={companyName}
            bookingDate={bookingDate}
            listDocDriver={listDocDriver}
            isExecutor
          />
        )}
        <OrdersInfoCargo item={cargoDetails} />
        <span className={style.orders_author}>
          <InfoIcon /> {getOrder?.author} {getOrder?.createdAtStr}
        </span>
      </div>
    </div>
  );
};

export default OrdersСard;
